export class MailRequestModel {
    requestId: string;
    from: string;
    to: string[];
    cc: string;
    bcc: string;
    subject: string;
    body: string;
    fromCompanyId: string;
    toCompanyId: string[];
    attachment: {}[];


    constructor() {
        this.requestId="";
        this.from="";
        this.to=[];
        this.cc= "";
        this.bcc="";
        this.subject="";
        this.body ="";
        this.fromCompanyId="";
        this.toCompanyId = [];
        this.attachment = [{}];
    }

     getCcArray(): string[] {
        return this.cc ? this.cc.split(",") : [];
    }
}
